<template>
  <div class="historyHome">
    <div class="page3-box" ref="scrollbar">
      <div class="list" v-for="(item, index) in dataArr" :key="index">
        <div class="list-heard" :id="item.year" :ref="item.year">
          <span>{{ item.year }}</span>
        </div>
        <div class="list-text" v-html="item.content"></div>
      </div>
    </div>
    <!-- <div class="time">
      <div
        class="item"
        :class="{ itemAct: item.year === itemId }"
        v-for="(item, index) in dataArr"
        :key="index"
        @click="getData(item.year)"
      >
        <span></span>
        {{ item.year }}
      </div>
    </div> -->
  </div>
</template>

<script>
import { getMemorabilia } from "@/api/api.js";

export default {
  data() {
    return {
      dataArr: [],
      itemId: null
    };
  },
  mounted() {
    this.getMemorabilia();
  },
  methods: {
    getMemorabilia() {
      getMemorabilia().then(res => {
        if (res.code === 0) {
          this.dataArr = res.data;
          this.itemId = this.dataArr[0].year;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    getData(y) {
      this.itemId = y;
      this.$refs.scrollbar.scrollTop = this.$refs[y][0].offsetTop - 16;
    }
  }
};
</script>

<style lang="less">
.historyHome {
  padding: 16px;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  .page3-box {
    // display: flex;
    // justify-content: space-between;
    // height: 100vh;
    // overflow-y: auto;
    .list-heard {
      margin-bottom: 30px;
      width: 100%;
      border-bottom: 1px dashed rgba(191, 195, 199, 1);
      span {
        display: inline-block;
        padding: 6px 14px;
        background: rgba(22, 81, 148, 1);
        font-size: 16px;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
      }
    }
    .list-text {
      font-size: 16px;
      // .list-h1 {
      //   margin-bottom: 20px;
      //   font-size: 18px;
      //   font-weight: bold;
      //   color: rgba(52, 52, 52, 1);
      // }
      // .list-h2 {
      //   margin-bottom: 20px;
      //   font-size: 16px;
      //   font-weight: bold;
      //   color: rgba(52, 52, 52, 1);
      // }
      // .list-h3 {
      //   margin-bottom: 20px;
      //   font-size: 16px;
      //   font-weight: 400;
      //   color: rgba(52, 52, 52, 1);
      //   text-indent: 2em;
      //   line-height: 24px;
      // }
    }
  }
  .time {
    display: flex;
    width: 100%;
    height: 50px;
    padding-bottom: 16px;
    overflow: hidden;
    overflow-x: auto;
    .item {
      position: relative;
      display: flex;
      align-items: center;
      padding: 0 10px;
      height: 50px;
      font-size: 16px;
      color: rgba(52, 52, 52, 1);
      cursor: pointer;
      border-bottom: 1px solid #ededed;
      span {
        position: absolute;
        bottom: -5px;
        left: 0;
        right: 0;
        margin: 0 auto;
        display: inline-block;
        width: 9px;
        height: 9px;
        background: rgba(191, 195, 199, 1);
        border-radius: 50%;
      }
    }
    .itemAct {
      color: rgba(22, 81, 148, 1);
      span {
        background: rgba(22, 81, 148, 1);
      }
    }
  }
}
</style>
